import React, { useEffect, useState } from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { hot } from "react-hot-loader/root";
import { Provider, useDispatch, useSelector } from "react-redux";
import { ThemeProvider } from "styled-components";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  useHistory,
} from "react-router-dom";
import { ConfigProvider, Spin, Tag } from "antd";
import store from "./redux/store";
import Admin from "./routes/admin";
import Panel from "./routes/panel";
import Auth from "./routes/auth";
import "./static/css/style.css";
import config from "./config/config";
import ProtectedRoute from "./components/utilities/protectedRoute";
import { getItem } from "./utility/localStorageControl";
import { apiRoutes } from "./config/dataService/apiRoutes";
import { ExtranetService } from "./config/dataService/userService";
import { setUserData } from "./redux/users/actionCreator";
import { logOut } from "./redux/authentication/actionCreator";
import { addNotificationError } from "./utility/notifications";
// import { useHistory } from 'react-import 'antd/dist/antd.css'; // para versiones < 5.0.0
import "antd/dist/antd.css";
const { theme } = config;

const ProviderConfig = () => {
  const { rtl, isLoggedIn, topMenu, darkMode, userprofile } = useSelector(
    (state) => {
      return {
        darkMode: state.ChangeLayoutMode.data,
        rtl: state.ChangeLayoutMode.rtlData,
        topMenu: state.ChangeLayoutMode.topMenu,
        isLoggedIn: state.auth.login,
        userprofile: state.userData.data,
      };
    }
  );
  const UserId = getItem("userId");
  const dispatch = useDispatch();
  const history = useHistory();
  const [path, setPath] = useState(window.location.pathname);

  useEffect(() => {
    // let unmounted = false;
    // if (!unmounted) {
    //   setPath(window.location.pathname);
    // }
    // return () => (unmounted = true);
    if (UserId && isLoggedIn) {
      const getUserData = (userId) => {
        return async () => {
          // const data = {
          //   user: userId,
          // };

          try {
            console.log("userId response", userId);

            const response = await ExtranetService.get(
              apiRoutes.users.getUser(userId)
            );
            console.log("getUser response", response.data);
            console.log("Object response", Object.keys(response.data).length);
            if (response && Object.keys(response.data).length) {
              dispatch(setUserData(response.data.data));
              let unmounted = false;
              if (!unmounted) {
                setPath(window.location.pathname);
              }
              // eslint-disable-next-line no-return-assign
              return () => (unmounted = true);
            } else {
              dispatch(
                setUserData({
                  name: "User",
                  lastname: "",
                })
              );
              dispatch(logOut());
            }
          } catch (err) {
            addNotificationError(
              "Ha surgido un error. Porfavor intentelo de nuevo"
            );
            dispatch(
              setUserData({
                name: "User",
                lastname: "",
              })
            );
            dispatch(logOut());
          }
        };
      };

      dispatch(getUserData(UserId));
    }
  }, [dispatch, setPath, UserId, isLoggedIn]);

  console.log("userprofile", userprofile);

  if (Object.keys(userprofile).length === 0) {
    // history.push('/');
    // ReactDOM.render(<div className="exampleSpin"><Spin/> </div>);
    // return <Redirect to="/"/>
    return (
      <div className="exampleSpin">
        <Spin />{" "}
      </div>
    );
  }

  return (
    <ConfigProvider direction={rtl ? "rtl" : "ltr"}>
      <ThemeProvider
        theme={{
          ...theme,
          rtl,
          topMenu: userprofile.isAdmin === "yes" ? false : true,
          darkMode: userprofile.isAdmin === "yes" ? false : true,
        }}
      >
        <Router basename={process.env.PUBLIC_URL}>
          {!isLoggedIn ? (
            <Route path="/" component={Auth} />
          ) : userprofile.isAdmin === "yes" ? (
            <ProtectedRoute path="/admin" component={Admin} />
          ) : (
            <ProtectedRoute path="/panel" component={Panel} />
          )}
          {isLoggedIn &&
            (path === process.env.PUBLIC_URL ||
              path === `${process.env.PUBLIC_URL}/`) && (
              <Redirect
                to={userprofile.isAdmin === "yes" ? "/admin" : "/panel"}
              />
            )}
        </Router>
      </ThemeProvider>
    </ConfigProvider>
  );
};

function App() {
  return (
    <Provider store={store}>
      <ProviderConfig />
    </Provider>
  );
}

export default hot(App);
